import { IOption, Label, Select } from '@gcl/react-core';
import * as React from 'react';
import { useDeepCompareEffectNoCheck } from 'use-deep-compare-effect';
import { StringFilter, IFilterInputBaseProps, StringsFilter } from '../searchFilter.models';
import { getFilterValue } from '../searchFilter.services';

export interface ITextSelectFilterInputProps extends IFilterInputBaseProps<StringFilter | StringsFilter> {}

export const TextSelectFilterInput: React.FunctionComponent<ITextSelectFilterInputProps> = ({
  fieldConfig,
  onChange,
  filter,
  disabled = false,
}) => {
  const [options, setOptions] = React.useState<IOption<any>[]>([]);
  const { displayName, fieldName, textSelectOptions, allowMultipleSelect, disable } = fieldConfig;
  const [selectedOption, setSelectedOption] = React.useState<IOption<any>[] | undefined>(undefined);

  useDeepCompareEffectNoCheck(() => {
    if (!textSelectOptions || textSelectOptions.length <= 0) {
      setOptions([]);
      return;
    }

    if (typeof textSelectOptions[0] === 'string')
      setOptions(
        (textSelectOptions || []).map((option) => {
          return { key: option.toString(), text: option.toString() };
        }),
      );
    else setOptions(textSelectOptions as IOption<string>[]);
  }, [textSelectOptions]);

  useDeepCompareEffectNoCheck(() => {
    const value = getFilterValue(fieldName, filter);

    if (!value) {
      setSelectedOption(undefined);
      return;
    }

    if (!allowMultipleSelect) {
      const str = value as string;
      const selected = options.find((o) => o.key === str);
      setSelectedOption(selected ? [selected] : undefined);
      return;
    }

    const strArr = value as string[];
    if (strArr)
      setSelectedOption(
        strArr
          .map((s) => {
            const selected = options.find((o) => o.key === s);
            return selected || { key: 'undefined', text: 'undefined' };
          })
          .filter((o) => o.key !== 'undefined' && o.text !== 'undefined'),
      );
  }, [JSON.stringify(filter), JSON.stringify(options)]);

  return (
    <>
      <Label labelFor={fieldName}>{displayName}</Label>
      <Select
        multiple={!!allowMultipleSelect}
        value={selectedOption || undefined}
        pageSize={options.length}
        displayFieldName="text"
        options={options}
        minSearchQueryLength={0}
        disabled={disabled || disable}
        allowSearch={!!allowMultipleSelect}
        onChange={(selected) => {
          if (!selected || selected.length <= 0) {
            setSelectedOption(undefined);
            onChange(fieldName, undefined);
            return;
          }
          setSelectedOption(selected);

          if (!allowMultipleSelect) {
            onChange(fieldName, selected[0].key.toString());
            return;
          }

          onChange(
            fieldName,
            selected.map((s) => {
              return s.key.toString();
            }),
          );
        }}
        id={fieldName}
      />
    </>
  );
};
